'use client';

import { useResizeObserver } from '@react-hookz/web';
import classNames from 'classnames';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var HORIZONTAL_LAYOUT_MIN_WIDTH = 480;
export function Container(_ref) {
  var {
    defaultLayout,
    children,
    className,
    hasThumbnail
  } = _ref;
  var [cardRef, setCardRef] = useState(null);
  var [isSmallViewport, setSmallViewport] = useState(false);
  useResizeObserver(cardRef, entry => {
    setSmallViewport(entry.contentRect.width < HORIZONTAL_LAYOUT_MIN_WIDTH);
  });
  var actualLayout = getActualLayout(hasThumbnail, isSmallViewport, defaultLayout);
  return /*#__PURE__*/_jsx("div", {
    ref: setCardRef,
    className: classNames(className, 'prezly-slate-bookmark-card-component__container', {
      vertical: actualLayout === 'vertical',
      horizontal: actualLayout === 'horizontal'
    }),
    children: children
  });
}
function getActualLayout(hasThumbnail, isSmallViewport, defaultLayout) {
  if (!hasThumbnail) {
    return 'horizontal';
  }
  if (isSmallViewport) {
    return 'vertical';
  }
  return defaultLayout;
}